<template>
    <div class="row justify-content-center">
        <div >
            <!-- Tabs with icons -->
            
            <tabs fill class="flex-column flex-md-row">
                <card shadow slot-scope="{activeTabIndex}">
                    <tab-pane key="tab1">
                        <template slot="title">
                            <i class="ni ni-bell-55 mr-2"></i>Giới Thiệu
                        </template>

                        <p class="description">Là doanh nghiệp cung cấp dịch vụ trung gian thanh toán và thương mại điện tử quy mô lớn nhất Việt Nam.
                        <p class="description">Luôn giữ vững vị thế là nhà phân phối hàng đầu cung cấp các sản phẩm và dịch vụ viễn thông của tất cả các đơn vị viễn thông trên toàn quốc.</p>
                    </tab-pane>

                    <tab-pane key="tab2">
                        <template slot="title">
                            <i class="ni ni-bell-55 mr-2"></i>Trợ giúp
                        </template>

                        <p class="description">Hướng dẫn sử dụng</p>
                        <p class="description">Câu hỏi thường gặp.</p>
                    </tab-pane>

                
                    <tab-pane key="tab3">
                        <template slot="title">
                            <i class="ni ni-bell-55 mr-2"></i>Liên hệ
                        </template>
                        <p class="description"> Số 10, ngõ 1, phố Đỗ Quang, P.Trung Hòa, Q.Cầu Giấy Hà Nội</p>
                        <p class="description">Holine: (+84) 2435 567 567</p>
                    </tab-pane>
                
                </card>
            </tabs>
        </div>
       
    </div>
</template>
<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
export default {
  components: {
    Tabs,
    TabPane
  }
};
</script>
<style>
</style>
